<template>
    <div class="main-body">
        <div class="header">
            服务人员列表
        </div>
        <div class="out">

            <div class="search2">

              <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="float:right">

                <el-input placeholder="请输入姓名" size="mini" v-model="name" clearable style="width:200px"></el-input>

                <el-select v-model="serviceStatus" size="mini" placeholder="请选择服务状态" style="margin-left: 10px;">
                    <el-option
                            v-for="(item,key) in serviceStatusValue"
                            :key="key"
                            :label="item"
                            :value="key">
                    </el-option>
                </el-select>

                <el-button style="margin-left:10px;float:right" type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>

              </div>

              <div style="clear: both;"></div>
            </div>

            <div style="height: 0px;"></div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border :header-cell-style="tabHeader">

              <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>

              <el-table-column prop="phone" label="APP账号" width="120"></el-table-column>

              <el-table-column prop="listServeStaffRelDTO" label="后台账号"   width="150">
                <template slot-scope="scope">
                  <span v-for="item in scope.row.listServeStaffRelDTO" v-bind:key="item.serveStaffRelCode">
                    <div>{{item.staffName}}</div>
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="idCard" label="身份证" width="200"></el-table-column>
              <el-table-column prop="gender" :formatter="genders" label="性别" width="80"></el-table-column>
              <el-table-column prop="age" label="年龄" width="80"></el-table-column>


              <el-table-column prop="serviceStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.serviceStatus == 0">默认</span>
                  <span v-if="scope.row.serviceStatus == 1">正常</span>
                  <span v-if="scope.row.serviceStatus == 2">禁用</span>
                </template>
              </el-table-column>


              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">
                  <p>{{scope.row.createTime | timefilters }}</p>
                </template>
              </el-table-column>



              <el-table-column fixed="right" label="操作" width="140">
                  <template slot-scope="scope">

                    <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
<!--                      <el-button type="text" size="mini" @click="handleEditStaff(scope.$index, scope.row)">关联后台账号</el-button>-->

                    <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

                  </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

      <EditStaff ref="myEditStaff" v-show="showModalEditStaff" v-on:closeEditStaff="closeEditStaff" v-on:getList="getList"></EditStaff>


      <el-dialog title="密码修改" :visible.sync="pwdDialog" class="dialog" width='400px' center top='30vh'
                 :close-on-click-modal='false'>
        <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                  show-password></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pwdDialog=false">取 消</el-button>
          <el-button type="primary" @click="editPassword">提交</el-button>
        </div>
      </el-dialog>


    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import EditStaff from "./EditStaff";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
      //注册局部过滤器
      filters: {
        timefilters(val) {
          if (val == null || val == "") {
            return "";
          } else {
            let d = new Date(val);   //val 为表格内取到的后台时间
            let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
            let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
          }
        }
      },
        data() {
            return {

                tableLoading: false,
                showModalEditStaff: false,

                showModalAdd: false,
                showModalEdit: false,
                name: '',
                serviceStatus: 0,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                serviceStatusValue: ['所有状态', '正常服务', '停止服务'],
                th: 0,

              pwdDialog: false,
              password: '',
              serveCode:'',

            }
        },
        components: {
            Add, Edit, EditStaff
        },
        created() {
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                console.log(val);
                this.th = val;
            },
        },
        methods: {

            // 修改table header的背景色
            tabHeader() {
                return 'color:#333;fonts-weight:bold;'
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },

            handleEditStaff(index, row) {
                this.$refs.myEditStaff.init(row);
                this.showModalEditStaff = !this.showModalEditStaff;
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            closeEditStaff: function () {
                this.showModalEditStaff = !this.showModalEditStaff;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeBinding: function () {
                this.showModalBinding = !this.showModalBinding;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

            genders(row) {
                if (row.gender == 0) {
                    return "女";
                }
                if (row.gender == 1) {
                    return "男";
                }
            },
            serviceStatu(row) {
                if (row.serviceStatus == 0) {
                    return "正常服务";
                }
                if (row.serviceStatus == 1) {
                    return "停止服务";
                }
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "Serve/Page2",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        name: this.name,
                        status: this.serviceStatus - 1,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                    }
                }).then((response) => {
                    _this.tableLoading=false
                    if (response.data.error == 0) {

                      this.tableData = response.data.data.pageInfo.list;
                      this.totalItems = response.data.data.pageInfo.total;
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },

          handlePassword(index,row) {
            this.pwdDialog = true;
            this.serveCode = row.serveCode;
            this.password = '';
          },
          editPassword() {

            if (this.password.length < 6) {
              this.$message('密码至少为六位')
              return;
            }

            this.$axios({
              method: 'post',
              url: this.$shopUrl + 'Serve/EditPassword',
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                staffCode: getStaffCode(),
                password: this.password,
                serveCode:this.serveCode,
              }
            }).then((response) => {
              //console.log(response);
              if (response.data.error == 0) {
                this.$message('修改成功');
                this.pwdDialog = false
              } else if (response.data.error == 1) {
                this.$message(response.data.message);
              } else {
                console.log(response.data.message);
              }

            }).catch(function (error) {
              console.log(error);
            });
          },


        }
    }
</script>

<style scoped>

</style>
